import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, image, swapTitles, imageVerticalPosition, isNewsBlock, dealer }) => ({
    borderBottom: `2px solid ${theme.colors.goldDark}`,
    borderRadius: '0 0 2px 2px',
    height: '100%',

    [theme.breakpoints.up('md')]: {
        display: 'flex'
    },

    [theme.breakpoints.up('lg')]: {
        borderBottom: `4px solid ${theme.colors.goldDark}`,
        borderRadius: '0 0 4px 4px'
    },

    '& .Image': {
        overflow: 'hidden',
        height: 360,
        borderRadius: '4px 4px 0 0',
        background: `url(${image}) no-repeat ${imageVerticalPosition} center`,
        backgroundSize: 'cover',

        [theme.breakpoints.up('md')]: {
            borderRadius: '0 4px 0 0',
            width: '50%',
            order: 2,
            height: '100%'
        }
    },

    '& .Content': {
        background: theme.colors.blueLight,
        padding: toRem(40),

        [theme.breakpoints.up('md')]: {
            width: image ? '50%' : '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        },

        [theme.breakpoints.up('xxl')]: {
            padding: toRem(60)
        },

        'a, button': {
            margin: dealer ? '0 auto 0 auto' : 'auto 0 0 0'
        },

        '&.dealer': {
            display: 'flex',
            flexDirection: 'column'
        }
    },

    '& h2': {
        fontSize: toRem(36),
        fontWeight: 600,
        color: theme.colors.goldDark,
        marginBottom: swapTitles ? toRem(40) : toRem(5),

        [theme.breakpoints.up('xl')]: {
            lineHeight: toRem(64),
            fontSize: isNewsBlock ? toRem(36) : toRem(50)
        },

        '&.dealer': {
            fontSize: toRem(24),
            lineHeight: toRem(36),
            textAlign: 'center',
            marginBottom: toRem(10)
        }
    },

    '& .dealerLogos': {
        listStyle: 'none',
        width: '100%',
        display: 'grid',
        gridColumnGap: toRem(20),
        gridRowGap: toRem(50),
        alignItems: 'center',

        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr'
        },

        li: {
            width: '100%',
            marginBottom: toRem(10),
            textAlign: 'center',

            // '&.princess': {
            //     [theme.breakpoints.up('md')]: {
            //         position: 'relative',
            //         top: toRem(20)
            //     },

            //     img: {
            //         maxWidth: 150
            //     }
            // },

            // '&.cranchi': {
            //     [theme.breakpoints.up('md')]: {
            //         position: 'relative',
            //         top: toRem(-7)
            //     },

            //     img: {
            //         maxWidth: 150
            //     }
            // }
        }
    },

    '& p': {
        fontSize: toRem(20),
        marginBottom: swapTitles ? toRem(5) : toRem(40),

        [theme.breakpoints.up('xl')]: {
            fontSize: isNewsBlock ? toRem(20) : toRem(24)
        },

        '&.dealer': {
            width: '100%',
            fontSize: toRem(12),
            marginTop: 'auto',
            marginBottom: toRem(20),
            textAlign: 'center',

            [theme.breakpoints.up('md')]: {
                fontSize: toRem(15)
            }
        }
    }
})

export default style
